import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";

class CopyUrl extends React.Component {
  state = {
    copied: "Copy Link",
  };

  onCopyUrl = () => {
    this.setState({
      copied: "Copied!",
    });

    setTimeout(() => {
      this.onRevertCopyState();
    }, 2000);
  };

  onRevertCopyState = () => {
    this.setState({
      copied: "Copy Link",
    });
  };

  render() {
    return (
      <div className="share-dialog__copy-url">
        <div className="share-dialog__url">
          <span>{this.props.url}</span>
        </div>

        <CopyToClipboard text={this.props.url} onCopy={this.onCopyUrl}>
          <div className="button button--copy-url">{this.state.copied}</div>
        </CopyToClipboard>
      </div>
    );
  }
}

export default CopyUrl;
